<!-- 权限树 -->
<template>
  <el-tree
    :class="[globalDisabled ? 'disabled-tree' : '']"
    :data="tree"
    highlight-current
    show-checkbox
    v-bind="$attrs"
    node-key="id"
    :props="defaultProps"
    @check="checkChange"
    ref="per"
  >
  </el-tree>
</template>

<script>
export default {
  props: {
    tree: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    globalDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    checkChange() {
      if (this.$isAuto) {
        return;
      }
      if (this.globalDisabled) {
        this.$refs.per.setCheckedKeys(this.modelValue);
        this.$emit('disableCheck');
        return;
      }
      const checkedList = this.$refs.per
        .getCheckedNodes()
        .filter((item) => item.isLeaf)
        .map((item) => item.id);
      checkedList.sort((a, b) => a - b);
      this.$emit('update:modelValue', checkedList);
    },
  },
  watch: {
    modelValue(val) {
      this.$isAuto = true;
      this.$refs.per.setCheckedKeys(val);
      this.$isAuto = false;
    },
  },
  setup() {
    return {
      defaultProps: {
        label: 'add_label',
        children: 'children',
      },
    };
  },
};
</script>

<style lang="scss">
.disabled-tree {
  .el-checkbox__inner {
    opacity: 0.5 !important;
  }
}
</style>
